import { render, staticRenderFns } from "./IBSCBS.vue?vue&type=template&id=0c808df4&"
import script from "./IBSCBS.vue?vue&type=script&lang=js&"
export * from "./IBSCBS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports